export default {
  ATTRIBUTE_MUTATION: 'ATTRIBUTE_MUTATION',
  DELETE_MUTATION: 'DELETE_MUTATION',
  INSERT_MUTATION: 'INSERT_MUTATION',
  REPLACE_MUTATION: 'REPLACE_MUTATION',
  SHIFT_MUTATION: 'SHIFT_MUTATION',
  HTML_MUTATION: 'HTML_MUTATION',
};
